import React, { useState, useEffect } from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";

import "react-circular-progressbar/dist/styles.css";

import InfoBox from "../common/template/infoBox";
import Content from "../common/template/content";
import ContentCard from "../common/template/contentCard";
import ContentCardBody from "../common/template/contentCardBody";
import Row from "../common/layout/row";
import Table from "../common/table/table";
import THead from "../common/table/tHead";
import Th from "../common/table/th";
import TBody from "../common/table/tBody";
import Tr from "../common/table/tr";
import Select from "../common/form/select";
import Grid from "../common/layout/grid";
import Button from "../common/button/button";

import somNotificacaoArquivo from "../assets/sounds/notificacao.wav";
import graphMonitor from "../assets/images/graphMonitor.png";
import plugInversor from "../assets/images/plugInversor.png";
import consumedEnergy from "../assets/images/consumedEnergy.png";
import calendarCheck from "../assets/images/calendar-check.svg";
import capacitor from "../assets/images/capacitor.png";
import volts from "../assets/images/volts.png";

import {
    setFiltro,
    setAguardando,
    setModoTela,
    setDataInicialGrafico,
    setDataFinalGrafico,
    getMonitoramentoConsumo,
    getListaGraficoDemanda,
    carregarListas,
    getListaGraficoDia,
    getListaGraficoTodasIntegracoesAgrupadasPorHora,
    setStatusVisualizado,
} from "./monitoramentoConsumoActions";

import { setEmitirAlertaSonoro } from "../usuario/usuarioActions";
import GraficoMonitoramentoConsumo from "./graficoMonitoramentoConsumo";
import GraficosPeQ from "./graficosPeQ";
import DateFormat from "../common/dateFormat/DateFormat";

import { setPeriodoTesteVisualizado } from "../demandaContrato/demandaContratoActions";
import { DisplayPDF } from "../displayPDF/displayPDF";
import { setArquivoPDF } from "../displayPDF/displayPDFActions";

import GraficoTabelaDemandaMensal from "./graficoDemandaContrato";
import { gerarRelatorio } from "../fatura/faturaActions.js";
import { convertToBase64 } from "../utils/convertToBase64.js";
import { Loading } from "../common/loading/loading";
import { useRef } from "react";
import { ModalHistoricoDemandas } from "./components/ModalHistoricoDemandas.jsx";
import { LinhaMonitoramentoConsumo } from "./components/LinhaMonitoramentoConsumo.jsx";
import { ModalGestorConcessonaria } from "../analise/components/ModalGestorConcessionaria.jsx";
import { LabelSelectUcIconeGestor } from "../common/form/LabelSelectUcIconeGestor.jsx";
import { calcularFatorPotencia } from "../core/calcularFatorPotencia.js";
import MonitoramentoConsumoBroker from "./monitoramentoConsumoBroker.jsx";
import { MonitoramentoConsumoCardMobile } from "./components/MonitoramentoConsumoCardMobile.jsx";
import { RowFlex } from "../common/layout/RowFlex.jsx";

// Variáveis de controle dentro da função principal
let sleepTimeoutId = null;
let idIntervaloNotificacao = null;
let idIntervaloBusca = null;
const COR_ULTRAPASSAGEM = "#ff3164";

function MonitoramentoConsumo(props) {
    const isMobile = window.innerWidth <= 768;
    const isAcessoCliente = props.usuarioLogado && props.usuarioLogado.acesso_cliente;

    const contentCardRef = useRef(null);
    const [loading, setLoading] = useState(false);
    const [dataHoraUltimaAtualizacao, setDataHoraUltimaAtualizacao] = useState(true);
    const [exibirModalHistorico, setExibirModalHistorico] = useState(false);
    const [exibirModalAnaliseDemandaContratada, setExibirModalAnaliseDemandaContratada] = useState(false);
    const [exibirModalGestorConcessionaria, setExibirModalGestorConcessionaria] = useState(false);
    const [itemSelecionado, setItemSelecionado] = useState(null);
    const [filtroLista, setFiltroLista] = useState({ apenasOnline: false, apenasOffline: false, apenasDemandasComUltrapassagem: false, apenasFatorPotenciaBaixo: false });
    const totaisPorStatus = { qtdOnline: 0, qtdOffline: 0, qtdDemandasComUltrapassagem: 0, qtdFatorPotenciaBaixo: 0 };

    useEffect(() => {
        props.carregarListas(); //cli, uc, tipo
        emitirAlertaSonoro();
        atualizarDadosCada15Min();
        return () => {
            cancelarTimersAlertaSonoro();
            cancelarTimerBuscaLista15min();
            // desmontarTodosGraficos();
        };
    }, []);

    useEffect(() => {
        emitirAlertaSonoro();
    }, [JSON.stringify(props.listaMonitoramentoConsumo), props.usuarioLogado.emitir_alerta_sonoro]);

    if (props.pdf) {
        return <DisplayPDF closePdf={() => props.setArquivoPDF()} pdfBase64={props.pdf} nomePdf={props.nomePdf} />;
    }

    const usuarioMaster = props.usuarioLogado && [1, 2].includes(props.usuarioLogado.id); // apenas ti e marthielo
    return (
        <div>
            {(props.aguardando || loading) && <Loading />}

            <Content>
                {props.modoTela === "broker" && usuarioMaster && <MonitoramentoConsumoBroker />}
                {props.modoTela === "lista" && listar()}
                {props.modoTela.includes("grafico") && <GraficosPeQ />}
                {props.modoTela === "detalharCardMobile" ? <MonitoramentoConsumoCardMobile /> : null}
            </Content>
        </div>
    );

    function listar() {
        const listaFiltrada = ordenarVencidosComAlerta(props.listaMonitoramentoConsumo).filter((item) => {
            //--------------------------------------------------------------------------------

            const q =
                Math.abs(parseFloat(item.consumoLeitura.kvar_ind) || 0) >=
                Math.abs(parseFloat(item.consumoLeitura.kvar_cap) || 0)
                    ? Math.abs(parseFloat(item.consumoLeitura.kvar_ind) || 0)
                    : Math.abs(parseFloat(item.consumoLeitura.kvar_cap) || 0) * -1;
            const fatorPotencia = calcularFatorPotencia({ p: item.consumoLeitura.kw, q });

            const demandaUltrapassada = item.consumoLeitura.cor_maior_demanda_mes === COR_ULTRAPASSAGEM;

            const naoCorrespondeFiltroDemandaUltrapassagem = filtroLista.apenasDemandasComUltrapassagem && !demandaUltrapassada;

            //define se está online ou offline ---------------------------------------------
            const dataHoraLeitura = new Date(item.consumoLeitura.data_hora);
            const dataHoraAtualValidacaoRecente = new Date();
            dataHoraAtualValidacaoRecente.setMinutes(dataHoraAtualValidacaoRecente.getMinutes() - 60);
            const onlineRecentemente = dataHoraLeitura >= dataHoraAtualValidacaoRecente;

            const naoCorrespondeFiltroFP = filtroLista.apenasFatorPotenciaBaixo && (isNaN(fatorPotencia) || fatorPotencia >= 0.92);
            const naoCorrespondeFiltroOnline = filtroLista.apenasOnline && !onlineRecentemente;
            const naoCorrespondeFiltroOffline = filtroLista.apenasOffline && onlineRecentemente;

            const ignorarLinha = naoCorrespondeFiltroDemandaUltrapassagem || naoCorrespondeFiltroFP || naoCorrespondeFiltroOnline || naoCorrespondeFiltroOffline;

            //---------------------------------------------------INCREMENTA OS TOTAIS DE CADA FILTRO------------------------------------------------------------
            //só contabiliza se estiver ok com os filtros
            if (!ignorarLinha) {
                if (totaisPorStatus.qtdDemandasComUltrapassagem >= 0 && demandaUltrapassada) {
                    totaisPorStatus.qtdDemandasComUltrapassagem++;
                }

                if (totaisPorStatus.qtdFatorPotenciaBaixo >= 0 && !isNaN(fatorPotencia) && fatorPotencia < 0.92) {
                    totaisPorStatus.qtdFatorPotenciaBaixo++;
                }

                if (onlineRecentemente && totaisPorStatus.qtdOnline >= 0) {
                    totaisPorStatus.qtdOnline++;
                }
                if (!onlineRecentemente && totaisPorStatus.qtdOffline >= 0) {
                    totaisPorStatus.qtdOffline++;
                }
            }
            return !ignorarLinha;
        });

        // VALORES DOS CARDS DO CABEÇALHO --------------------------------------
        const totalUsinas = 0;
        const potenciaTotalInstalada = (0).toFixed(2).replace(".", ",") + " MW";

        const energiaTotalDia = (0).toFixed(2).replace(".", ",") + " MWh";
        const energiaTotalMes = (0).toFixed(2).replace(".", ",") + " MWh";

        const totalUsinasProducaoModerada = 0;
        const totalUsinasProducaoBaixa = 0;
        //----------------------------------------------------------------------

        //CARDS

        const cardsTotalizadores = (
            <>
                <Grid cols="12 6 6 6" style={{ paddingLeft: window.innerWidth < 992 ? 0 : null }}>
                    <InfoBox text="Número de Unidades" number={totalUsinas} style={{ height: window.innerWidth < 992 ? null : 50, fontSize: "0.9rem" }} minHeight={50}>
                        <img
                            src={graphMonitor}
                            style={{
                                height: 30,
                                width: 30,
                                filter: "brightness(0) invert(1)",
                            }}
                            alt=""
                        />
                    </InfoBox>
                </Grid>
                <Grid cols="12 6 6 6" style={{ paddingLeft: window.innerWidth < 992 ? 0 : null }}>
                    <InfoBox
                        text="Potência Total Instalada"
                        number={potenciaTotalInstalada}
                        style={{ height: window.innerWidth < 992 ? null : 50, fontSize: "0.9rem" }}
                        minHeight={50}
                    >
                        <img
                            src={plugInversor}
                            style={{
                                height: 40,
                                width: 40,
                                filter: "brightness(0) invert(1)",
                            }}
                            alt=""
                        />
                    </InfoBox>
                </Grid>
                <Grid cols="12 6 6 6" style={{ paddingLeft: window.innerWidth < 992 ? 0 : null }}>
                    <InfoBox
                        text="Energia Total Consumida no Dia"
                        number={energiaTotalDia}
                        style={{ height: window.innerWidth < 992 ? null : 50, fontSize: "0.9rem" }}
                        minHeight={50}
                    >
                        <img
                            src={consumedEnergy}
                            style={{
                                height: 40,
                                width: 40,
                                filter: "brightness(0) invert(1)",
                            }}
                            alt=""
                        />
                    </InfoBox>
                </Grid>
                <Grid cols="12 6 6 6" style={{ paddingLeft: window.innerWidth < 992 ? 0 : null }}>
                    <InfoBox
                        text="Energia Total Consumida no Mês"
                        number={energiaTotalMes}
                        style={{ height: window.innerWidth < 992 ? null : 50, fontSize: "0.9rem" }}
                        minHeight={50}
                    >
                        <img
                            src={calendarCheck}
                            style={{
                                height: 30,
                                width: 30,
                                filter: "brightness(0) invert(1)",
                            }}
                            alt=""
                        />
                    </InfoBox>
                </Grid>
            </>
        );

        const cardsStatusProducao = (
            <>
                <Grid cols="12 6 6 6" style={{ paddingLeft: window.innerWidth < 992 ? 0 : null }}>
                    <InfoBox
                        icon="fas fa-check"
                        text="Operando Normalmente"
                        number={totaisPorStatus.qtdOnline}
                        twoColors="#3EFF3E"
                        minHeight={50}
                        checked={filtroLista.apenasOnline}
                        onClick={() => {
                            setFiltroLista({
                                ...filtroLista,
                                apenasOnline: !filtroLista.apenasOnline,
                            });
                        }}
                    />
                </Grid>
                <Grid cols="12 6 6 6" style={{ paddingLeft: window.innerWidth < 992 ? 0 : null }}>
                    <InfoBox
                        icon="fas fa-exclamation-triangle"
                        text="Sem Comunicação ou Desligado"
                        number={totaisPorStatus.qtdOffline}
                        twoColors="#F56969"
                        minHeight={50}
                        checked={filtroLista.apenasOffline}
                        onClick={() => {
                            setFiltroLista({
                                ...filtroLista,
                                apenasOffline: !filtroLista.apenasOffline,
                            });
                        }}
                    />
                </Grid>
                <Grid cols="12 6 6 6" style={{ cursor: "pointer", paddingLeft: window.innerWidth < 992 ? 0 : null, fontSize: "0.8rem" }}>
                    <InfoBox
                        text="Adv. por Fator de Potência Baixo"
                        textBold
                        number={totaisPorStatus.qtdFatorPotenciaBaixo}
                        twoColors="#34c6ff"
                        minHeight={50}
                        checked={filtroLista.apenasFatorPotenciaBaixo}
                        onClick={() => {
                            setFiltroLista({
                                ...filtroLista,
                                apenasFatorPotenciaBaixo: !filtroLista.apenasFatorPotenciaBaixo,
                            });
                        }}
                    >
                        <img
                            src={capacitor}
                            style={{
                                height: 40,
                                width: 40,
                            }}
                            alt=""
                        />
                    </InfoBox>
                </Grid>
                <Grid cols="12 6 6 6" style={{ cursor: "pointer", paddingLeft: window.innerWidth < 992 ? 0 : null, fontSize: "0.8rem" }}>
                    <InfoBox
                        text="Adv. por Ultrapassagem de Demanda"
                        textBold
                        number={totaisPorStatus.qtdDemandasComUltrapassagem}
                        twoColors="#ff360e"
                        minHeight={50}
                        checked={filtroLista.apenasDemandasComUltrapassagem}
                        icon="fas fa-bolt"
                        onClick={() => {
                            setFiltroLista({
                                ...filtroLista,
                                apenasDemandasComUltrapassagem: !filtroLista.apenasDemandasComUltrapassagem,
                            });
                        }}
                    />
                </Grid>
                <Grid cols="12 6 6 6" style={{ paddingLeft: window.innerWidth < 992 ? 0 : null, fontSize: "0.8rem" }}>
                    <InfoBox text="Advertência por Tensão Baixa" textBold number={totalUsinasProducaoModerada} twoColors="#ffe53b" minHeight={50}>
                        <img
                            src={volts}
                            style={{
                                height: 45,
                                width: 45,
                            }}
                            alt=""
                        />
                    </InfoBox>
                </Grid>
                <Grid cols="12 6 6 6" style={{ paddingLeft: window.innerWidth < 992 ? 0 : null, fontSize: "0.8rem" }}>
                    <InfoBox text="Advertência por Tensão Alta" textBold number={totalUsinasProducaoBaixa} twoColors="#ffa600" minHeight={50}>
                        <img
                            src={volts}
                            style={{
                                height: 50,
                                width: 50,
                            }}
                            alt=""
                        />
                    </InfoBox>
                </Grid>
            </>
        );
        //----------------------------------------------------------------------

        if (props.pdf) {
            return <DisplayPDF closePdf={() => props.setArquivoPDF()} pdfBase64={props.pdf} nomePdf={props.nomePdf} />;
        }

        const listaUcsFiltradas = listarUCsFiltradas();
        const isMobileCliente = isMobile && isAcessoCliente;

        //só mostra se tem alguma uc que é horosazonal azul e que tem contrato ponta
        const exibirFiltroTipoContratoDemanda = !!listaFiltrada.find((item) => item.id_modalidade_tarifaria == 2 && item.demanda_ponta_contratada_mes_atual);

        const clienteLogado = props.usuarioLogado && props.usuarioLogado.acesso_cliente;
        return (
            <div ref={contentCardRef}>
                {props.aguardando ? <Loading /> : null}
                {exibirModalHistorico && itemSelecionado && !props.pdf ? (
                    <ModalHistoricoDemandas setItemSelecionado={setItemSelecionado} setExibirModalHistorico={setExibirModalHistorico} itemSelecionado={itemSelecionado} />
                ) : null}
                {exibirModalAnaliseDemandaContratada && itemSelecionado && !props.pdf ? (
                    <GraficoTabelaDemandaMensal
                        setItemSelecionado={setItemSelecionado}
                        setExibirModalAnaliseDemandaContratada={setExibirModalAnaliseDemandaContratada}
                        itemSelecionado={itemSelecionado}
                    />
                ) : null}
                <ModalGestorConcessonaria
                    visible={exibirModalGestorConcessionaria && itemSelecionado && itemSelecionado.gestor_concessionaria_energia}
                    itemSelecionado={itemSelecionado}
                    handleClose={() => {
                        setExibirModalGestorConcessionaria(false);
                        setItemSelecionado(null);
                    }}
                />
                <Content>
                    <ContentCard style={{ marginTop: isMobile ? 20 : null }}>
                        <ContentCardBody>
                            {usuarioMaster && (
                                <RowFlex style={{ justifyContent: "flex-end" }}>
                                    <Grid cols="12 6 3 3">
                                        <Button
                                            style={{ height: 40, margin: 0 }}
                                            title="Visualizar leituras do broker MQTT"
                                            text="Broker MQTT"
                                            solid={true}
                                            type={"dark"}
                                            icon="fas fa-broadcast-tower"
                                            event={() => {
                                                props.setModoTela("broker");
                                            }}
                                        />
                                    </Grid>
                                </RowFlex>
                            )}
                            {isMobileCliente ? null : (
                                <Row
                                    style={{
                                        marginBottom: 5,
                                        justifyContent: "space-between",
                                        paddingInline: 10,
                                    }}
                                >
                                    {window.innerWidth > 768 || (props.usuarioLogado && !props.usuarioLogado.acesso_cliente) ? <GraficoMonitoramentoConsumo /> : null}
                                    <Grid cols="12 12 12 6">
                                        {window.innerWidth > 768 ? (
                                            <Row>
                                                {cardsTotalizadores}
                                                {cardsStatusProducao}
                                            </Row>
                                        ) : (
                                            <details
                                                open={props.usuarioLogado && !props.usuarioLogado.acesso_cliente}
                                                style={{
                                                    marginTop: 20,
                                                    padding: 20,
                                                    fontSize: "1.1rem",
                                                    border: "1px solid #ddd",
                                                    borderRadius: 5,
                                                }}
                                            >
                                                <summary>
                                                    <b>Exibir totalizadores</b>
                                                </summary>
                                                <Row style={{ marginTop: 10 }}>
                                                    {props.usuarioLogado && props.usuarioLogado.acesso_cliente ? <GraficoMonitoramentoConsumo /> : null}
                                                    {cardsTotalizadores}
                                                    {cardsStatusProducao}
                                                </Row>
                                            </details>
                                        )}
                                    </Grid>
                                </Row>
                            )}
                            {isMobileCliente ? (
                                <Row>
                                    {exibirFiltroTipoContratoDemanda && (
                                        <Select
                                            style={{ margin: 0 }}
                                            name="demanda_contrato_tipos"
                                            options={props.listaDemandaContratoTipo.filter((tipo) => {
                                                if (!props.filtro.id_cliente && tipo.id != 3) return true;
                                                const ucFiltradaPeloCliente = props.listaUnidadeConsumidora.filter((uc) => uc.id_cliente == props.filtro.id_cliente);
                                                const condicaoForaPonta = tipo.id == 1;
                                                const condicaoPonta = tipo.id == 2 && !!ucFiltradaPeloCliente.find((uc) => uc.id_modalidade_tarifaria == 2); //alguma uc do cliente selecionado tem q ser horosazonal azul
                                                return condicaoForaPonta || condicaoPonta;
                                            })}
                                            label="Tipo de Contrato de Demanda"
                                            cols="10 11 11 11"
                                            placeholder="Selecione o tipo de contrato de demanda"
                                            value={props.filtro.id_tipo_contrato_demanda}
                                            isClearable={false}
                                            isSearchable={false}
                                            onChange={(id_tipo_contrato_demanda) => {
                                                props.setFiltro({
                                                    ...props.filtro,
                                                    id_tipo_contrato_demanda,
                                                });
                                            }}
                                        />
                                    )}
                                    {exibirFiltroTipoContratoDemanda ? (
                                        <Grid
                                            cols={"2 1 1 1"}
                                            style={{
                                                display: "flex",
                                                alignItems: "center",
                                                flexDirection: "column",
                                                paddingLeft: window.innerWidth < 992 ? 0 : null,
                                            }}
                                        >
                                            <Button
                                                solid={true}
                                                style={{ color: "#fff", transform: "scaleX(-1)", padding: 2, height: 28 }}
                                                text={
                                                    <i style={{ fontSize: "0.8rem" }} className={props.usuarioLogado.emitir_alerta_sonoro ? "far fa-bell" : "far fa-bell-slash"} />
                                                }
                                                type={"warning"}
                                                event={props.setEmitirAlertaSonoro}
                                            />
                                            <Button
                                                style={{ color: "#fff", padding: 2, height: 28 }}
                                                solid={true}
                                                text={<i style={{ fontSize: "0.8rem" }} className={"fas fa-sync"} />}
                                                type={"primary"}
                                                event={props.getMonitoramentoConsumo}
                                            />
                                        </Grid>
                                    ) : (
                                        <>
                                            <Grid
                                                cols={"6 6 6 6"}
                                                style={{
                                                    display: "flex",
                                                    alignItems: "center",
                                                    flexDirection: "column",
                                                    paddingLeft: window.innerWidth < 992 ? 0 : null,
                                                }}
                                            >
                                                <Button
                                                    solid={true}
                                                    style={{ color: "#fff", transform: "scaleX(-1)", padding: 2, height: 28 }}
                                                    text={
                                                        <i
                                                            style={{ fontSize: "0.8rem" }}
                                                            className={props.usuarioLogado.emitir_alerta_sonoro ? "far fa-bell" : "far fa-bell-slash"}
                                                        />
                                                    }
                                                    type={"warning"}
                                                    event={props.setEmitirAlertaSonoro}
                                                />
                                            </Grid>
                                            <Grid
                                                cols={"6 6 6 6"}
                                                style={{
                                                    display: "flex",
                                                    alignItems: "center",
                                                    flexDirection: "column",
                                                    paddingLeft: window.innerWidth < 992 ? 0 : null,
                                                }}
                                            >
                                                <Button
                                                    style={{ color: "#fff", padding: 2, height: 28 }}
                                                    solid={true}
                                                    text={<i style={{ fontSize: "0.8rem" }} className={"fas fa-sync"} />}
                                                    type={"primary"}
                                                    event={props.getMonitoramentoConsumo}
                                                />
                                            </Grid>
                                        </>
                                    )}
                                </Row>
                            ) : (
                                <Row>
                                    <>
                                        {clienteLogado ? null : (
                                            <Select
                                                style={{ margin: 0 }}
                                                name="id_cliente"
                                                options={props.listaCliente}
                                                label="Cliente"
                                                cols="12 12 3 3"
                                                placeholder="Selecione o Cliente"
                                                value={props.filtro.id_cliente}
                                                onChange={(value) => {
                                                    props.setFiltro({
                                                        ...props.filtro,
                                                        id_cliente: value,
                                                        id_unidade_consumidora: null,
                                                    });
                                                    // buscarDadosTela();
                                                }}
                                            />
                                        )}
                                        <Select
                                            style={{ margin: 0 }}
                                            options={listaUcsFiltradas}
                                            label={
                                                <LabelSelectUcIconeGestor
                                                    isMulti={true}
                                                    filtro={props.filtro}
                                                    listaUnidadeConsumidora={listaUcsFiltradas}
                                                    setExibirModal={(ucFiltro) => {
                                                        setExibirModalGestorConcessionaria(true);
                                                        setItemSelecionado(ucFiltro);
                                                    }}
                                                />
                                            }
                                            cols={
                                                props.usuarioLogado && props.usuarioLogado.acesso_cliente
                                                    ? exibirFiltroTipoContratoDemanda
                                                        ? "12 12 6 6"
                                                        : "12 12 8 8"
                                                    : exibirFiltroTipoContratoDemanda
                                                      ? "12 12 3 3"
                                                      : "12 12 5 5"
                                            }
                                            placeholder="Selecione as UCs"
                                            isMulti={true}
                                            value={props.filtro.unidades_consumidoras}
                                            onChange={(ucsSelecionadas) => {
                                                const ucQualquerDoFiltro = ucsSelecionadas[0] || {};
                                                const ucCompleta = props.listaUnidadeConsumidora.find((uc) => ucQualquerDoFiltro.value == uc.id) || { id_cliente: null };
                                                props.setFiltro({
                                                    ...props.filtro,
                                                    unidades_consumidoras: [...ucsSelecionadas],
                                                    id_cliente: props.filtro.id_cliente || ucCompleta.id_cliente,
                                                });
                                            }}
                                        />
                                    </>

                                    {exibirFiltroTipoContratoDemanda && (
                                        <Select
                                            style={{ margin: 0 }}
                                            name="demanda_contrato_tipos"
                                            options={props.listaDemandaContratoTipo.filter((tipo) => {
                                                if (!props.filtro.id_cliente && tipo.id != 3) return true;
                                                const ucFiltradaPeloCliente = props.listaUnidadeConsumidora.filter((uc) => uc.id_cliente == props.filtro.id_cliente);
                                                const condicaoForaPonta = tipo.id == 1;
                                                const condicaoPonta = tipo.id == 2 && !!ucFiltradaPeloCliente.find((uc) => uc.id_modalidade_tarifaria == 2); //alguma uc do cliente selecionado tem q ser horosazonal azul
                                                return condicaoForaPonta || condicaoPonta;
                                            })}
                                            label="Tipo de Contrato de Demanda"
                                            cols="12 12 2 2"
                                            placeholder="Selecione o tipo de contrato de demanda"
                                            value={props.filtro.id_tipo_contrato_demanda}
                                            isClearable={false}
                                            isSearchable={false}
                                            onChange={(id_tipo_contrato_demanda) => {
                                                props.setFiltro({
                                                    ...props.filtro,
                                                    id_tipo_contrato_demanda,
                                                });
                                            }}
                                        />
                                    )}

                                    <Grid
                                        cols="12 12 1 1"
                                        style={{
                                            paddingTop: 15,
                                            display: "flex",
                                            justifyContent: "center",
                                            alignItems: "flex-start",
                                            paddingLeft: window.innerWidth < 992 ? 0 : null,
                                        }}
                                    >
                                        <Button
                                            solid={true}
                                            style={{
                                                marginTop: 13,
                                                color: "#fff",
                                                transform: "scaleX(-1)",
                                            }}
                                            text={
                                                props.usuarioLogado.emitir_alerta_sonoro ? (
                                                    <i style={{ fontSize: "1.2rem" }} className="far fa-bell" />
                                                ) : (
                                                    <i style={{ fontSize: "1.2rem" }} className="far fa-bell-slash" />
                                                )
                                            }
                                            type={"warning"}
                                            event={props.setEmitirAlertaSonoro}
                                        />
                                    </Grid>
                                    <Grid cols="12 12 1 1" style={{ paddingTop: 29, paddingRight: 15 }}>
                                        <Button text="Imprimir" type={"dark"} icon={"fa fa-print"} event={() => handleExport({ quantidadeLinhas: listaFiltrada.length })} />
                                    </Grid>
                                    <Grid cols="12 12 2 2" style={{ paddingTop: 29, paddingRight: 15 }}>
                                        <Button text="Atualizar" type={"primary"} icon={"fa fa-sync"} event={props.getMonitoramentoConsumo} />
                                    </Grid>
                                    <Grid cols="12 12 12 12" style={{ textAlign: "right", paddingRight: 15 }}>
                                        <span style={{ textAlign: "right", width: "100%", color: "#777" }}>
                                            <i>
                                                {"Atualizada em "}
                                                {dataHoraUltimaAtualizacao}
                                            </i>
                                        </span>
                                    </Grid>
                                </Row>
                            )}
                        </ContentCardBody>
                    </ContentCard>

                    {isMobile && isAcessoCliente ? (
                        listaFiltrada.map((item, i, listaAtual) => {
                            return (
                                <MonitoramentoConsumoCardMobile
                                    item={item}
                                    backgroundColor={"#023b49"}
                                    color={"#FFF"}
                                    loading={loading}
                                    key={item.id_unidade_consumidora}
                                    COR_ULTRAPASSAGEM={COR_ULTRAPASSAGEM}
                                    setItemSelecionado={setItemSelecionado}
                                    ultimaLinha={i === listaAtual.length - 1}
                                    setExibirModalHistorico={setExibirModalHistorico}
                                    setExibirModalAnaliseDemandaContratada={setExibirModalAnaliseDemandaContratada}
                                />
                            );
                        })
                    ) : (
                        <ContentCardBody>
                            <Table
                                id="tabela-monitoramento-consumo"
                                responsive
                                style={{
                                    paddingTop: 0,
                                    minWidth: 890,
                                }}
                            >
                                <THead>
                                    <Tr>
                                        <Th backgroundColor={"#FFFFFF"} sticky alignCenter>
                                            Demandas Atingidas
                                        </Th>
                                        <Th minWidth={100} backgroundColor={"#FFFFFF"} sticky alignCenter>
                                            <div>Índices de</div>
                                            <div>Sazonalidade/</div>
                                            <div>Fator de Carga</div>
                                        </Th>
                                        {props.usuarioLogado.administrador ? (
                                            <Th backgroundColor={"#FFFFFF"} sticky>
                                                Cliente
                                            </Th>
                                        ) : null}
                                        <Th backgroundColor={"#FFFFFF"} sticky>
                                            Unidade Consumidora
                                        </Th>
                                        <Th backgroundColor={"#FFFFFF"} sticky alignCenter>
                                            Gráfico
                                        </Th>
                                        <Th minWidth={50} backgroundColor={"#FFFFFF"} sticky alignCenter>
                                            <p style={{ margin: 0 }}>P</p>(kW)
                                        </Th>
                                        <Th minWidth={50} backgroundColor={"#FFFFFF"} sticky alignCenter>
                                            <p style={{ margin: 0 }}>Q</p>(kVAr)
                                        </Th>
                                        <Th minWidth={50} backgroundColor={"#FFFFFF"} sticky alignCenter>
                                            <p style={{ margin: 0 }}>S</p>(kVA)
                                        </Th>
                                        <Th minWidth={50} backgroundColor={"#FFFFFF"} sticky alignCenter>
                                            <p style={{ margin: 0 }}>I</p>(Ampere)
                                        </Th>
                                        <Th minWidth={50} backgroundColor={"#FFFFFF"} sticky alignCenter>
                                            <p style={{ margin: 0 }}>V</p>(volts)
                                        </Th>
                                        <Th minWidth={50} backgroundColor={"#FFFFFF"} sticky alignCenter>
                                            <p style={{ margin: 0 }}>FP</p>
                                        </Th>
                                        <Th minWidth={100} backgroundColor={"#FFFFFF"} sticky alignCenter>
                                            <table>
                                                <thead>
                                                    <tr>
                                                        <th colSpan={4} style={{ border: "none" }}>
                                                            P (kW) Máx. no Mês (Demanda)
                                                        </th>
                                                    </tr>
                                                    <tr>
                                                        <th
                                                            style={{
                                                                border: "1px solid #ddd",
                                                                padding: 4,
                                                                textAlign: "center",
                                                                minWidth: 90,
                                                                textWrap: "nowrap",
                                                                fontSize: "0.8rem",
                                                            }}
                                                        >
                                                            Descrição
                                                        </th>
                                                        <th
                                                            style={{
                                                                border: "1px solid #ddd",
                                                                padding: 4,
                                                                textAlign: "center",
                                                                minWidth: 100,
                                                                textWrap: "nowrap",
                                                                fontSize: "0.8rem",
                                                            }}
                                                        >
                                                            Data/Hora
                                                        </th>
                                                        <th
                                                            style={{
                                                                border: "1px solid #ddd",
                                                                padding: 4,
                                                                textAlign: "center",
                                                                minWidth: 60,
                                                                textWrap: "nowrap",
                                                                fontSize: "0.8rem",
                                                            }}
                                                        >
                                                            Demanda
                                                        </th>
                                                        <th
                                                            style={{
                                                                border: "1px solid #ddd",
                                                                padding: 4,
                                                                textAlign: "center",
                                                                minWidth: 80,
                                                                textWrap: "nowrap",
                                                                fontSize: "0.8rem",
                                                            }}
                                                        >
                                                            Consumo
                                                        </th>
                                                    </tr>
                                                </thead>
                                            </table>
                                        </Th>
                                        <Th minWidth={150} backgroundColor={"#FFFFFF"} sticky alignCenter>
                                            Valor de Demanda Contratada do Mês Atual (kW)
                                        </Th>
                                    </Tr>
                                </THead>
                                <TBody>
                                    {listaFiltrada.map((item, i, listaAtual) => {
                                        return (
                                            <LinhaMonitoramentoConsumo
                                                item={item}
                                                loading={loading}
                                                key={item.id_unidade_consumidora}
                                                COR_ULTRAPASSAGEM={COR_ULTRAPASSAGEM}
                                                setItemSelecionado={setItemSelecionado}
                                                ultimaLinha={i === listaAtual.length - 1}
                                                setExibirModalHistorico={setExibirModalHistorico}
                                                setExibirModalAnaliseDemandaContratada={setExibirModalAnaliseDemandaContratada}
                                            />
                                        );
                                    })}
                                </TBody>
                            </Table>
                        </ContentCardBody>
                    )}
                </Content>
            </div>
        );
    }

    function buscarDadosTela() {
        setDataHoraUltimaAtualizacao(DateFormat.formatarDataHoraSqlParaTela(DateFormat.getDataHoraAtual()));
        props.getMonitoramentoConsumo();
    }

    function atualizarDadosCada15Min() {
        const quinzeMinutosMs = 1000 * 60 * 15;
        buscarDadosTela();
        if (!idIntervaloBusca) {
            console.log("iniciando intervalo busca");
            idIntervaloBusca = setInterval(() => buscarDadosTela(), quinzeMinutosMs);
        }
    }

    function cancelarTimerBuscaLista15min() {
        if (idIntervaloBusca !== null) {
            console.log("Cancelando intervalo busca tela");
            clearInterval(idIntervaloBusca);
            idIntervaloBusca = null; // Redefine para garantir que só há um intervalo ativo
        }
    }

    function cancelarTimersAlertaSonoro() {
        // Cancela qualquer timeout ou intervalo em andamento antes de iniciar um novo
        if (sleepTimeoutId !== null) {
            console.log("Cancelando timer alerta anterior");
            clearTimeout(sleepTimeoutId);
            sleepTimeoutId = null; // Redefine para garantir que só há um timer ativo
        }
        if (idIntervaloNotificacao !== null) {
            console.log("Cancelando intervalo alerta anterior");
            clearInterval(idIntervaloNotificacao);
            idIntervaloNotificacao = null; // Redefine para garantir que só há um intervalo ativo
        }
    }

    function emitirAlertaSonoro() {
        // Função interna para iniciar o processo de alerta
        const iniciarAlerta = () => {
            console.log({ sleepTimeoutId, idIntervaloNotificacao });
            cancelarTimersAlertaSonoro();
            // Define o tempo de espera de 2 minutos
            const doisMinutos = 1000 * 60 * 2;

            // Inicia um novo timer de 2 minutos
            sleepTimeoutId = setTimeout(async () => {
                // Verifica leituras com erro
                const leiturasComErro = props.listaMonitoramentoConsumo.find((item) => {
                    //valida erro fp

                    const fatorPotencia = calcularFatorPotencia({
                        p: item.consumoLeitura.kw,
                        q:
                            Math.abs(parseFloat(item.consumoLeitura.kvar_ind) || 0) >=
                            Math.abs(parseFloat(item.consumoLeitura.kvar_cap) || 0)
                                ? Math.abs(parseFloat(item.consumoLeitura.kvar_ind) || 0)
                                : Math.abs(parseFloat(item.consumoLeitura.kvar_cap) || 0) * -1,
                    });                    

                    let exibirAlertaPkwVermelho = false;
                    //1 fora ponta e 2 ponta
                    if (props.filtro.id_tipo_contrato_demanda == 1) {
                        exibirAlertaPkwVermelho = parseFloat(item.consumoLeitura.kw) > parseFloat(item.demanda_fora_ponta_contratada_mes_atual) * 1.05;
                    } else if (props.filtro.id_tipo_contrato_demanda == 2) {
                        exibirAlertaPkwVermelho = parseFloat(item.consumoLeitura.kw) > parseFloat(item.demanda_ponta_contratada_mes_atual) * 1.05;
                    }

                    const erroFatorPotencia = !isNaN(fatorPotencia) && fatorPotencia < 0.92 && !item.consumoLeitura.status_visualizado_fp;
                    const erroKw = exibirAlertaPkwVermelho && !item.consumoLeitura.status_visualizado_kw;

                    const erroDemandaUltrapassada =
                        (item.consumoLeitura.cor_demanda_ponta === COR_ULTRAPASSAGEM && !item.consumoLeitura.status_visualizado_demanda_ponta) ||
                        (item.consumoLeitura.cor_demanda_fora_ponta === COR_ULTRAPASSAGEM && !item.consumoLeitura.status_visualizado_demanda_fora_ponta) ||
                        (item.consumoLeitura.cor_demanda_reservado === COR_ULTRAPASSAGEM && !item.consumoLeitura.status_visualizado_demanda_reservado) ||
                        (item.consumoLeitura.cor_demanda_geracao === COR_ULTRAPASSAGEM && !item.consumoLeitura.status_visualizado_demanda_geracao);

                    return erroFatorPotencia || erroKw || erroDemandaUltrapassada;
                });

                // Emite o alerta se todas as condições estiverem corretas
                if (!!leiturasComErro && props.usuarioLogado.emitir_alerta_sonoro) {
                    console.log("deve emitir");
                    if (!idIntervaloNotificacao) {
                        console.log("Emitindo alerta sonoro");
                        idIntervaloNotificacao = setInterval(async () => {
                            try {
                                const somNotificacao = new Audio(somNotificacaoArquivo);
                                await somNotificacao.play();
                            } catch (erro) {
                                console.log("Erro ao tentar emitir som: ", erro);
                            }
                        }, 3000);
                    }
                }
            }, doisMinutos); // Espera de 2 minutos (120000 ms)

            console.log("Novo timer iniciado:", sleepTimeoutId);
        };

        // Inicia o alerta
        iniciarAlerta();
    }

    function listarUCsFiltradas() {
        return props.listaUnidadeConsumidora.filter((item) => {
            const filtroClienteValidado = props.usuarioLogado.acesso_cliente
                ? item.id_cliente == props.usuarioLogado.id_cliente
                : !props.filtro.id_cliente || item.id_cliente == props.filtro.id_cliente;
            return filtroClienteValidado && [1, 4].includes(parseInt(item.id_grupo_faturamento));
        });
    }

    function ordenarVencidosComAlerta(lista) {
        const inicioMesAtual = new Date();
        inicioMesAtual.setDate(1);
        inicioMesAtual.setHours(0, 0, 0, 0);

        const getDataFim = (periodo) => {
            if (!Array.isArray(periodo) || !periodo.length) return null;
            try {
                const ultimo = JSON.parse(periodo[periodo.length - 1]);
                return new Date(parseInt(ultimo.ano), parseInt(ultimo.mes) - 1, 1);
            } catch {
                return null;
            }
        };

        // Grupo 1: vencidos e não visualizados
        const vencidosNaoVisualizados = [];

        // Grupo 2: vencidos já visualizados
        const vencidosVisualizados = [];

        // Grupo 3: os demais (vigentes ou sem período)
        const vigentes = [];

        const semPeriodoTeste = [];

        for (const item of lista) {
            const dataFim = getDataFim(item.periodo_teste);
            if (dataFim && dataFim < inicioMesAtual && !item.alerta_periodo_teste_visualizado) {
                vencidosNaoVisualizados.push(item);
            } else if (dataFim && dataFim < inicioMesAtual && item.alerta_periodo_teste_visualizado) {
                vencidosVisualizados.push(item);
            } else if (dataFim >= inicioMesAtual) {
                vigentes.push(item);
            } else if (!dataFim) {
                semPeriodoTeste.push(item);
            }
        }

        vencidosNaoVisualizados.sort((a, b) => {
            const dataA = getDataFim(a.periodo_teste);
            const dataB = getDataFim(b.periodo_teste);
            return dataA - dataB;
        });

        vencidosVisualizados.sort((a, b) => {
            const dataA = getDataFim(a.periodo_teste);
            const dataB = getDataFim(b.periodo_teste);
            return dataA - dataB;
        });

        semPeriodoTeste.sort((a, b) => {
            return (
                Boolean(
                    b.consumoLeitura.cor_maior_demanda_mes === COR_ULTRAPASSAGEM ||
                    b.consumoLeitura.cor_demanda_ponta === COR_ULTRAPASSAGEM ||
                    b.consumoLeitura.cor_demanda_fora_ponta === COR_ULTRAPASSAGEM ||
                    b.consumoLeitura.cor_demanda_reservado === COR_ULTRAPASSAGEM ||
                    b.consumoLeitura.cor_demanda_geracao === COR_ULTRAPASSAGEM
                ) -
                Boolean(
                    a.consumoLeitura.cor_maior_demanda_mes === COR_ULTRAPASSAGEM ||
                    a.consumoLeitura.cor_demanda_ponta === COR_ULTRAPASSAGEM ||
                    a.consumoLeitura.cor_demanda_fora_ponta === COR_ULTRAPASSAGEM ||
                    a.consumoLeitura.cor_demanda_reservado === COR_ULTRAPASSAGEM ||
                    a.consumoLeitura.cor_demanda_geracao === COR_ULTRAPASSAGEM
                )
            );
        });

        // Junta tudo, deixando os com ultrapassagem de demanda por primeiro
        return [...vencidosNaoVisualizados, ...vencidosVisualizados, ...vigentes, ...semPeriodoTeste];
    }

    async function handleExport({ quantidadeLinhas }) {
        const LINHAS_POR_PAGINA = 19;
        const ALTURA_LINHA = 130;
        const linhasUltimaPagina = quantidadeLinhas % LINHAS_POR_PAGINA;
        const espacoRestanteUltimaPagina = (LINHAS_POR_PAGINA - linhasUltimaPagina) * ALTURA_LINHA; // considerando altura média de 130px por linha

        console.log("Exportando relatório de monitoramento de consumo...");
        setLoading(true);
        const getTamanhoBase = () => {
            const zoomAtual = Math.floor(window.devicePixelRatio * 100);
            let tamanhoBase = 1750;
            if (window.innerWidth >= 768) {
                if (zoomAtual > 80 && zoomAtual <= 100) {
                    tamanhoBase = 1820;
                } else if (zoomAtual > 75 && zoomAtual <= 80) {
                    tamanhoBase = 1850;
                } else if (zoomAtual >= 70 && zoomAtual <= 75) {
                    tamanhoBase = 1900;
                } else if (zoomAtual >= 60 && zoomAtual <= 70) {
                    tamanhoBase = 2050;
                } else if (zoomAtual >= 50 && zoomAtual <= 60) {
                    tamanhoBase = 2450;
                } else if (zoomAtual < 50) {
                    return alert("Ajuste o zoom do navegador para 100% e tente novamente");
                }

                if (zoomAtual > 100 && zoomAtual <= 110) {
                    tamanhoBase = 1850;
                } else if (zoomAtual > 110 && zoomAtual <= 125) {
                    tamanhoBase = 1870;
                } else if (zoomAtual > 125 && zoomAtual <= 150) {
                    tamanhoBase = 2500;
                } else if (zoomAtual > 150 && zoomAtual <= 175) {
                    tamanhoBase = 4900;
                } else if (zoomAtual > 175) {
                    return alert("Ajuste o zoom do navegador para 100% e tente novamente");
                }
            }
            return tamanhoBase;
        };

        const calcularWidthTabela = ({ el, desconto = 0 }) => {
            if (window.innerWidth < 768) {
                el.style.fontSize = "0.7rem";
                el.style.zoom = "0.60"; // ajusta de verdade o tamanho do elemento
                el.style.width = 1700 - desconto + "px";
            } else {
                el.style.minWidth = `${(window.devicePixelRatio < 1 ? 1 + (1 - window.devicePixelRatio) : 2 - window.devicePixelRatio) * getTamanhoBase() - desconto}px`;
            }
        };

        const formatarTabela = ({ el, heightCelula }) => {
            if (el) {
                calcularWidthTabela({ el });
            }
        };

        if (contentCardRef.current) {
            const tabelaMonitoramentoConsumo = contentCardRef.current.querySelector("#tabela-monitoramento-consumo");

            formatarTabela({ el: tabelaMonitoramentoConsumo });
            const base64Cabecalho = await convertToBase64("/images/cabecalho_relatorio.png");
            const htmlCabecalho = `<div style="border: 1px solid #DDD; font-family: Arial, sans-serif;"><div style="width:100%; height:10%;">
                        <img src="${base64Cabecalho}" width="100%" />
                    </div>`;

            const base64Rodape = await convertToBase64("/images/rodape_relatorio.png");
            const htmlRodape = `<div style="width:100%; padding-top:${
                quantidadeLinhas < 16 ? 0 : espacoRestanteUltimaPagina
            }px; height:4%; display:flex; flex-direction:column; align-items:center; justify-content:flex-end;">
                                <img src="${base64Rodape}" width="100%" />
                            </div>
                        </div> `;

            const htmlTabelaMonitoramentoConsumo = tabelaMonitoramentoConsumo
                ? `<div ${quantidadeLinhas < 16 ? ' style="height:84%;"' : ""}>` + tabelaMonitoramentoConsumo.outerHTML + "</div>"
                : "";

            let html = htmlCabecalho + htmlTabelaMonitoramentoConsumo + htmlRodape;
            await props.gerarRelatorio({
                html,
                landscape: false,
                scale: window.innerWidth < 768 ? 0.62 : window.devicePixelRatio * 0.4,
            });
            setLoading(false);
        } else {
            console.error("ContentCard não está acessível.");
        }
    }
}

const mapStateToProps = (state) => {
    return {
        usuarioLogado: state.auth.usuarioLogado,
        aguardando: state.monitoramentoConsumo.aguardando,
        modoTela: state.monitoramentoConsumo.modoTela,
        filtro: state.monitoramentoConsumo.filtro,
        listaCliente: state.monitoramentoConsumo.listaCliente,
        listaUnidadeConsumidora: state.monitoramentoConsumo.listaUnidadeConsumidora,
        listaMonitoramentoConsumo: state.monitoramentoConsumo.listaMonitoramentoConsumo,
        listaDemandaContratoTipo: state.monitoramentoConsumo.listaDemandaContratoTipo,
        dataInicialGrafico: state.monitoramentoConsumo.dataInicialGrafico,
        dataFinalGrafico: state.monitoramentoConsumo.dataFinalGrafico,
        pdf: state.displayPDF.pdf,
        nomePdf: state.displayPDF.nomePdf,
    };
};
const mapDispatchToProps = (dispatch) =>
    bindActionCreators(
        {
            setFiltro,
            setAguardando,
            setModoTela,
            setDataInicialGrafico,
            setDataFinalGrafico,
            getMonitoramentoConsumo,
            getListaGraficoDemanda,
            carregarListas,
            getListaGraficoDia,
            getListaGraficoTodasIntegracoesAgrupadasPorHora,
            setStatusVisualizado,
            setEmitirAlertaSonoro,
            setPeriodoTesteVisualizado,
            setArquivoPDF,
            gerarRelatorio,
        },
        dispatch
    );
export default connect(mapStateToProps, mapDispatchToProps)(MonitoramentoConsumo);
